module.exports = __webpack_public_path__ + "5d2fea7609541d37edda3d51e5ea1484.pdf";